module.exports = __webpack_public_path__ + "static/img/help_10class_01.8e1edb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_10class_01.png
// module id = 711
// module chunks = 140